export const lineTagTracking = (type: string): void => {
  window._lt(
    'send',
    'cv',
    {
      type,
    },
    ['23526b4a-11a7-4a22-8559-5c14c996e31a'],
  )
}
